"use client";
import { jsx as e, jsxs as l } from "react/jsx-runtime";
import { Table as r, Html as m, Paragraph as t } from "@ingeniorforeningen/figurine-core";
import { forwardRef as b } from "react";
const s = b((n, T) => {
  const {
    items: { headers: a, rows: c }
  } = n;
  return /* @__PURE__ */ e("div", { ref: T, children: /* @__PURE__ */ l(r, { children: [
    /* @__PURE__ */ e(r.Thead, { children: /* @__PURE__ */ l(r.Tr, { children: [
      /* @__PURE__ */ e(r.Th, { children: a?.header1 }),
      /* @__PURE__ */ e(r.Th, { children: a?.header2 }),
      /* @__PURE__ */ e(r.Th, { children: a?.header3 })
    ] }) }),
    /* @__PURE__ */ e(r.Tbody, { children: c?.map(({ column1: d, column2: h, column3: i }, o) => /* @__PURE__ */ l(r.Tr, { children: [
      /* @__PURE__ */ e(r.Td, { "aria-label": d, children: /* @__PURE__ */ e(m, { html: d }) }),
      /* @__PURE__ */ e(r.Td, { "aria-label": h, children: /* @__PURE__ */ e(t, { text: h }) }),
      /* @__PURE__ */ e(r.Td, { "aria-label": i, children: /* @__PURE__ */ e(t, { text: i }) })
    ] }, `tableItem${o}`)) })
  ] }) });
});
s.displayName = "Tables3Columns";
const u = s;
export {
  s as _Tables3Columns,
  u as default
};
